import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

// export const getProjectsList = (id, query, token) => {
//   let qs = buildQuery(query);
//   let url = `${baseUrl}/projects/user/${id}${qs}`;
//   return axios.get(url, {
//     headers: {
//       authorization: token,
//     },
//   });
// };

export const getAllSiteCountbyProject = (token,query) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/getSiteCountbyProject${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};


export const insertSiteForProjectData = (data, token) => {
  return axios.post(`${baseUrl}/insertSiteForProject`, data, {
    headers: {
      authorization: token,
    },
  });
};

